if (!customElements.get('add-to-cart-card')) {
  customElements.define('add-to-cart-card', class AddToCartCard extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        selectedVariant: this.querySelector('.selected-variant'),
        variants: this.querySelectorAll('[id^="Variants"]'),
      }
      
      this.elements.variants.forEach((btn) => {
        btn.addEventListener('click', this.setActiveVariant.bind(this, btn))

      });
    }
    setActiveVariant(variant) {
      this.elements.selectedVariant.option = variant.dataset.id;
    }
  });
}
